
































import Vue from 'vue';
import { PropSync, Prop, Component, Watch } from 'vue-property-decorator';
import { Card } from '@/store/cards/CardInterface';
import { Action } from 'vuex-class';
import marked from 'marked';
import dompurify from 'dompurify';

@Component
export default class CardDisplayComponent extends Vue {
    @Action('updateCardData', { namespace: 'cardList' }) updateCardData: any;
    @Prop() item!: Card;
    @Prop() editable = false;

    @Watch('editable') onEditableChanged(
        val: boolean,
        prevValue: boolean
    ): void {
        // if the previous value was false, we area just entering into edit mode, no need to save.
        if (!prevValue) {
            return;
        }
        this.updateCardData(this.getData());
    }

    getData(): Card {
        return {
            ...this.item,
            name: (this.$refs.name as HTMLElement).innerText,
            imageUrl: (this.$refs.imageInput as HTMLInputElement).value,
            description: (this.$refs.descriptionEditor as HTMLInputElement)
                .value,
        };

        // https://i.pinimg.com/236x/28/f6/7c/28f67c6da291522c8b49db26cbfe15ab.jpg
    }

    get compiledMarkdown(): string {
        return dompurify.sanitize(
            marked(this.item.description || '', { breaks: true })
        );
    }
}
